export function getAvatarInitials(firstname, lastname) {
	const f = (firstname && String(firstname).trim().charAt(0)) || "";
	const l = (lastname && String(lastname).trim().charAt(0)) || "";
	if (f && l) return (f + l).toUpperCase();
	if (f) return f.toUpperCase();
	return "?";
}

export function getFullname(firstname, lastname) {
	return [firstname, lastname].filter(Boolean).join(" ") || "-";
}
